"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _faLock = _interopRequireDefault(require("@fortawesome/fontawesome-free-solid/faLock"));

var _faTimes = _interopRequireDefault(require("@fortawesome/fontawesome-free-solid/faTimes"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactIntl = require("react-intl");

var _ShareUnlockButton = _interopRequireDefault(require("./ShareUnlockButton"));

require("./OverlayLogin.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var OverlayShare = function OverlayShare(_ref) {
  var onClose = _ref.onClose;
  return _react.default.createElement("div", {
    className: "music overlay"
  }, _react.default.createElement("span", {
    className: "mt-1 mr-1 overlay_close_icon"
  }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.default,
    size: "1x",
    onClick: onClose
  })), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faLock.default,
    size: "3x",
    className: "overlay_icon mb-2 mt-5"
  }), _react.default.createElement("span", {
    className: "mb-2"
  }, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: "overlay_share_message"
  })), _react.default.createElement(_ShareUnlockButton.default, null));
};

OverlayShare.propTypes = {
  onClose: _propTypes.default.func.isRequired
};
var _default = OverlayShare;
exports.default = _default;